<div class="c-form-field c-form-field--d c-form-field--img-uploader">
  <div class="c-form-field__body">
    <div class="c-form-field__placeholder" *ngIf="!value">
      <div class="mb-13">
        <p500-ui-icon name="file-download" size="32px"></p500-ui-icon>
      </div>
      <div class="d-flex"><span>Upload your file with Drag&Drop or</span>&nbsp;<span class="text-color--primary">Attach file</span></div>
      <span class="text-color text-color--gray">{{ additional }}. Size limit is {{ fileSizeLimit }} Mb</span>
      <input type="file" class="c-form-field__file-input" [accept]="accept" />
    </div>
    <div class="c-form-field__uploaded" *ngIf="value">
      <div class="c-form-field__data">
        <div class="c-form-field__data-row" *ngIf="fileData.format">
          <span class="text-color text-color--gray mr-8">Name:</span>
          <span>{{ fileData.name }}</span>
        </div>
        <div class="c-form-field__data-row" *ngIf="fileData.format">
          <span class="text-color text-color--gray mr-8">Format:</span>
          <span>{{ fileData.format | uppercase }}</span>
        </div>
        <div class="c-form-field__data-row" *ngIf="fileData.size">
          <span class="text-color text-color--gray mr-8">Size:</span>
          <span>{{ fileData.size }}</span>
        </div>
        <button type="button" p500-ui-confluent-button color="warn" class="mt-6" (click)="removeFile()">Delete File</button>
      </div>
    </div>
  </div>
</div>
